import { useMutation } from "@tanstack/react-query";

import { createClientRateLimit } from "../../lib/clientRateLimit";

import { type SubmitStationRequestArgs, submitStationRequest } from "./api";

const rateLimit = createClientRateLimit(
  "voltaroute.station-requests.lastByName",
  24 * 60 * 60 * 1000,
);

export class RateLimitedError extends Error {
  constructor() {
    super("RATE_LIMITED");
    this.name = "RateLimitedError";
  }
}

function nameKey(name: string): string {
  return name.trim().toLowerCase();
}

export function useSubmitStationRequest() {
  return useMutation<void, Error, SubmitStationRequestArgs>({
    mutationFn: async (args) => {
      const key = nameKey(args.name);
      if (!rateLimit.canRequest(key)) {
        throw new RateLimitedError();
      }
      await submitStationRequest(args);
      rateLimit.mark(key);
    },
  });
}
